import { Routes, Route } from 'react-router-dom';
import ResetPassword from './pages/ResetPassword';
import UserHome from './pages/UserHome';
import Register from './pages/Register';
import Login from './pages/Login';
import PrivateRoute from './context/PrivateRoute';

const App = () => {
  return (
    <Routes>
      <Route path="/resetpassword" element={<ResetPassword/>} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />

      {/* Add more routes later */}

      <Route path="/userhome" element=
        {
          < PrivateRoute >
            <UserHome />
          </PrivateRoute >
        } 
      />
    </Routes>
  );
};

export default App;

